import { schema } from "normalizr";

export const disease = new schema.Entity(
  "diseases",
  {},
  { idAttribute: "disease_id" }
);
